import { createContext, useContext, type Context } from 'react';

import type { IProductBundleState } from './productBundle.interfaces';
import { initialState } from './productBundle.state';

export const ProductBundleContext: Context<IProductBundleState> =
  createContext(initialState);

export function useProductBundle() {
  return useContext(ProductBundleContext);
}
ProductBundleContext.displayName = 'Product Bundle';
